<template>
  <div id="app">
    <keep-alive max="10">
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
<!--    <keep-alive>-->
<!--      <router-view></router-view>-->
<!--    </keep-alive>-->
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  export default {
    computed:{
      ...mapState([
          'loading'
      ])
    },
  }
</script>
<style lang="scss">
#app{
  max-width: 750px;
  // height: 100%;
  min-height: 100%;
  margin: 0 auto;

  // overflow: hidden;
}
/*暂无图片*/
.dg-no-photo {
  background: #f5f5f5 url('./assets/images/dg-no-photo1.png') no-repeat;
  background-size: 120px 116px;
  background-position: center center
}
.dg-small-no-photo {
  background: #f5f5f5 url('./assets/images/dg-no-photo1.png') no-repeat;
  background-size: 70px 66px;
  background-position: center center
}
.default-photo {
  background: #f5f5f5 url('./assets/images/no-login.png') no-repeat;
  background-size: 100% 100%;
  background-position: center center
}
.van-dialog__confirm {
  .van-button__text{
    color: $fc07
  }
}
.dg-no-data{
  width: 100%;
   background: $bg01 url('./assets/images/nodata.png') no-repeat;
   background-size: 250px 240px;
   background-position: center center;
   height: 500px;
   font-size: 30px;
   color: $fc09;
   text-align: center;
   line-height: 780px;
}
.dg-no-order{
  width: 100%;
   background: $bg01 url('./assets/images/no-order.png') no-repeat;
   background-size: 210px 210px;
   background-position: center center;
   height: 500px;
   font-size: 30px;
   color: $fc09;
   text-align: center;
   line-height: 780px;
}
.dg-no-car-data{
  width: 100%;
  background: $bg01 url('./assets/images/no-car-data.png') no-repeat;
  background-size: 210px 210px;
  background-position: center center;
  height: 500px;
  font-size: 30px;
  color: $fc09;
  text-align: center;
  line-height: 780px;
}
.dg-no-search-data{
  width: 100%;
  background: $bg01 url('./assets/images/no-search-data.png') no-repeat;
  background-size: 210px 210px;
  background-position: center center;
  height: 500px;
}
.loading-box{
  width: 100%!important;
  height: 100%!important;
  position: fixed!important;
  z-index: 9999;
  .van-loading{
    padding: 20px;
    border-radius: 10px;
    width: 120px!important;
    height: 120px!important;
    position: absolute!important;
    left: 50%;
    top: 50%;
    margin-left: -60px;
    margin-right: -60px;
    background: rgba(0,0,0,.6);
  }
}
</style>
